var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_230_128147)" } }, [
        _c("path", {
          attrs: {
            d: "M15.2113 3.28983L13.6197 0.770383C13.478 0.545383 13.2252 0.406494 12.9558 0.406494H3.04465C2.77521 0.406494 2.52243 0.545383 2.38077 0.770383L0.786321 3.28983C-0.0359013 4.58983 0.691876 6.39816 2.22799 6.60649C2.3391 6.62038 2.45299 6.62872 2.5641 6.62872C3.2891 6.62872 3.93354 6.31205 4.37521 5.82316C4.81688 6.31205 5.46132 6.62872 6.18632 6.62872C6.91132 6.62872 7.55577 6.31205 7.99743 5.82316C8.4391 6.31205 9.08354 6.62872 9.80854 6.62872C10.5363 6.62872 11.178 6.31205 11.6197 5.82316C12.0641 6.31205 12.7058 6.62872 13.4308 6.62872C13.5447 6.62872 13.6558 6.62038 13.7669 6.60649C15.3085 6.40094 16.0391 4.59261 15.2141 3.28983H15.2113ZM13.8808 7.48705H13.878C13.7308 7.50649 13.5808 7.51761 13.428 7.51761C13.0835 7.51761 12.753 7.46483 12.4447 7.37038V11.0732H3.55577V7.36761C3.24465 7.46483 2.91132 7.51761 2.56688 7.51761C2.4141 7.51761 2.26132 7.50649 2.1141 7.48705H2.11132C1.99743 7.47038 1.88632 7.45094 1.77799 7.42316V11.0732V12.8509C1.77799 13.8315 2.57521 14.6287 3.55577 14.6287H12.4447C13.4252 14.6287 14.2224 13.8315 14.2224 12.8509V11.0732V7.42316C14.1113 7.45094 14.0002 7.47316 13.8808 7.48705Z",
            fill: "#010A11",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_230_128147" } }, [
          _c("rect", {
            attrs: {
              width: "16",
              height: "14.2222",
              fill: "white",
              transform: "translate(0 0.406738)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }